import { SelectOption } from '../models';

export const BLOC_VOLTAGES = [12, 6, 4, 2] as number[];

export class BlocVoltageHelper {
  static getOptions(
    allowedVoltages: readonly number[] = BLOC_VOLTAGES,
  ): SelectOption[] {
    return allowedVoltages.map((blocVoltage) => ({
      label: String(blocVoltage),
      value: blocVoltage,
    }));
  }
}
